import React from 'react';
import CONFIG from '../../../config';

interface IButtonProps {
  content: string;
  redirect: string;
  loaded?: boolean;
  handleClick?: () => void;
}

const ViewAllGamesBtn = ({
                           content,
                           redirect,
                           handleClick
                         }: IButtonProps) => {
  return (
    <div className="button-wrapper auto-width btn">
      <button
        className={`button btn-havelock-blue`}
        data-alt-text={content}
        data-event="globalClickEvent"
        onClick={() => {
          handleClick();
          if (CONFIG.isUPC) {
            window.location.href = redirect;
          } else {
            let win = window.open(redirect, '_blank');
            win.focus();
          }
        }}
      >
        <span data-alt-text={content}>{content}</span>
      </button>
    </div>
  );
};

export default ViewAllGamesBtn;
